import {Controller} from "stimulus"

export default class extends Controller {

    static targets = ["mainBody", "cLightBox", "cLightBoxWrapper"];

}
